export enum ProductTypes {
  OnDemand = 'OnDemand',
  Subscription = 'Subscription',
  Hardware = 'Hardware',
  AddOn = 'AddOn',
  Insurance = 'Insurance',
  Internet = 'Internet'
}
export enum ProductAddonListType {
  SingleRow,
  DualRow,
  LongRow,
}
